<template>
  <div
    style="position: relative; height: 100%; width: 100%"
    :style="`min-height: ${minHeight};`"
    class="bordered-1"
    :class="{ rounded: rounded }"
  >
    <!-- The main div -->
    <div
      ref="map"
      style="height: 100%"
      :class="{ rounded: rounded }"
      :style="{
        minHeight: minHeight,
      }"
    ></div>

    <!-- Overlay Element -->
    <v-sheet
      class="fab-overlay pa-2 rounded container container--fluid"
      v-if="!hideOverlay"
      :class="{ 'py-2': !hideAddress }"
      style="width: 100%"
    >
      <v-slide-x-reverse-transition
        v-if="!hideAddress"
        group
        leave-absolute
        hide-on-leave
        class="row row--dense d-flex justify-space-between"
        style="width: 100%"
        tag="div"
      >
        <v-col
          cols="12"
          class="d-flex justify-space-between align-center"
          key="address"
          style="width: 100%; gap: 8px"
        >
          <div
            class="d-flex flex-column align-start grow"
            style="max-width: 75%"
          >
            <span
              class="text-caption text-lg-body-2 font-weight-medium text--secondary d-flex align-start"
              style="font-size: x-small !important"
            >
              Address
            </span>
            <span
              class="text-caption text-lg-body-2 font-weight-bold d-flex text-wrap align-start"
              v-html="address.formatted.replace('\n', '<br />')"
            />
          </div>
          <div class="d-flex flex-column align-start">
            <v-menu offset-y top :nudge-top="12" rounded="xl">
              <template v-slot:activator="{ on, attrs, value }">
                <v-btn color="v-sheet" icon small v-bind="attrs" v-on="on">
                  <v-icon small color="review"> mdi-dots-vertical </v-icon>
                </v-btn>
              </template>
              <v-list dense color="v-sheet" content-class="rounded-lg">
                <AvatarListCell
                  :icon="true"
                  :dense="true"
                  src="mdi-directions"
                  title="Get Directions"
                  @click="handleDirections"
                />
                <AvatarListCell
                  :icon="true"
                  :dense="true"
                  src="mdi-export-variant"
                  title="Share Address"
                  @click="handleShare"
                />
              </v-list>
            </v-menu>
          </div>
        </v-col>
      </v-slide-x-reverse-transition>
      <v-row v-if="hideAddress" dense class="d-flex justify-space-between">
        <v-col cols="6" sm="12" lg="6">
          <div style="position: relative; height: 100%">
            <v-sheet
              class="directions-overlay rounded-lg"
              :style="`background-color: ${$vuetify.theme.currentTheme.secondary}82;`"
              style="height: 100%; width: 100%"
            />
            <v-btn
              color="review"
              :style="`background-color: ${$vuetify.theme.currentTheme.review}33 ;`"
              class="rounded-lg text-caption font-weight-bold"
              block
              text
              :href="addressURL"
              target="_blank"
            >
              <v-icon small left>mdi-car</v-icon>
              directions
            </v-btn>
          </div>
        </v-col>
        <v-col cols="6" sm="12" lg="6">
          <v-btn
            color="review"
            class="rounded-lg text-caption font-weight-bold"
            block
            text
            outlined
            @click="handleShare"
          >
            <v-icon small left>mdi-export-variant</v-icon>
            share
          </v-btn>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
// Libraries
import { mapGetters } from "vuex";
import gmapsInit from "@/utils/gmaps";
// Components

export default {
  name: "map-view",
  props: [
    "markers",
    "height",
    "coordinates",
    "address",
    "rounded",
    "hideOverlay",
    "hideAddress",
  ],
  data: () => ({
    loading: {
      overall: false,
    },
    coords: {},
    map: null,
  }),
  mounted() {
    if (typeof HTMLDialogElement === "undefined") {
      class HTMLDialogElement extends HTMLElement {
        showModal() {
          this.style.display = "block";
        }
        close() {
          this.style.display = "none";
        }
      }
      window.HTMLDialogElement = HTMLDialogElement;
    }
  },
  created() {
    this.setup();
  },
  watch: {
    async coordinates(value) {
      if (value) {
        await this.setup();
      }
    },
  },
  methods: {
    /* API Calls */
    // GET
    async initMap() {
      const google = await gmapsInit();

      const geocoder = new google.maps.Geocoder();

      let lat =
        this.coordinates._lat ??
        this.coordinates.lat ??
        this.coordinates.latitude;
      let long =
        this.coordinates._long ??
        this.coordinates.long ??
        this.coordinates.longitude;

      if (!lat || !long) {
        // return;
      }
      let coordinates = {
        lat,
        long,
      };

      const map = new google.maps.Map(this.$refs.map, {
        disableDefaultUI: true,
        mapId: "DEMO_MAP_ID",
        zoom: 14,
        // styles: [
        //   { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
        //   {
        //     elementType: "labels.text.stroke",
        //     stylers: [{ color: "#242f3e" }],
        //   },
        //   { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
        //   {
        //     featureType: "administrative.locality",
        //     elementType: "labels.text.fill",
        //     stylers: [{ color: "#d59563" }],
        //   },
        //   {
        //     featureType: "poi",
        //     elementType: "labels.text.fill",
        //     stylers: [{ color: "#d59563" }],
        //   },
        //   {
        //     featureType: "poi.park",
        //     elementType: "geometry",
        //     stylers: [{ color: "#263c3f" }],
        //   },
        //   {
        //     featureType: "poi.park",
        //     elementType: "labels.text.fill",
        //     stylers: [{ color: "#6b9a76" }],
        //   },
        //   {
        //     featureType: "road",
        //     elementType: "geometry",
        //     stylers: [{ color: "#38414e" }],
        //   },
        //   {
        //     featureType: "road",
        //     elementType: "geometry.stroke",
        //     stylers: [{ color: "#212a37" }],
        //   },
        //   {
        //     featureType: "road",
        //     elementType: "labels.text.fill",
        //     stylers: [{ color: "#9ca5b3" }],
        //   },
        //   {
        //     featureType: "road.highway",
        //     elementType: "geometry",
        //     stylers: [{ color: "#746855" }],
        //   },
        //   {
        //     featureType: "road.highway",
        //     elementType: "geometry.stroke",
        //     stylers: [{ color: "#1f2835" }],
        //   },
        //   {
        //     featureType: "road.highway",
        //     elementType: "labels.text.fill",
        //     stylers: [{ color: "#f3d19c" }],
        //   },
        //   {
        //     featureType: "transit",
        //     elementType: "geometry",
        //     stylers: [{ color: "#2f3948" }],
        //   },
        //   {
        //     featureType: "transit.station",
        //     elementType: "labels.text.fill",
        //     stylers: [{ color: "#d59563" }],
        //   },
        //   {
        //     featureType: "water",
        //     elementType: "geometry",
        //     stylers: [{ color: "#17263c" }],
        //   },
        //   {
        //     featureType: "water",
        //     elementType: "labels.text.fill",
        //     stylers: [{ color: "#515c6d" }],
        //   },
        //   {
        //     featureType: "water",
        //     elementType: "labels.text.stroke",
        //     stylers: [{ color: "#17263c" }],
        //   },
        // ],
      });
      map.setCenter({ lat: coordinates.lat, lng: coordinates.long });

      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: {
          lat: coordinates.lat,
          lng: coordinates.long,
        },
        map: map,
        title: this.address.formatted,
      });
    },
    // POST
    /* Main */
    async setup() {
      this.loading.overall = true;
      try {
        await this.initMap();
      } catch (error) {
        console.log(error);
      }
      this.loading.overall = false;
    },
    /* Misc */
    handleShare() {
      if (navigator.canShare(this.shareData)) {
        navigator
          .share(this.shareData)
          .catch((error) => console.error("Error sharing:", error));
      } else {
        this.$root.toast.show({
          message: "There was an error sharing this content.",
          color: "error",
          icon: "mdi-alert",
        });
        console.log("Web Share API not supported in this browser.");
      }
    },
    handleDirections() {
      window.open(this.addressURL, "_blank");
    },
  },
  computed: {
    ...mapGetters(["getAppName"]),
    isAppleDevice() {
      return /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);
    },
    addressURL() {
      const encodedAddress = encodeURIComponent(this.address.formatted);
      if (this.isAppleDevice) {
        // Use `maps://` for native Apple Maps app (iOS/macOS)
        return `maps://?q=${encodedAddress}`;
      } else {
        // Fallback to Google Maps for non-Apple devices
        return `https://www.google.com/maps/search/?q=${encodedAddress}`;
      }
    },
    shareURL() {
      const encodedAddress = encodeURIComponent(this.address.formatted);
      if (this.isAppleDevice) {
        // Use `maps://` for native Apple Maps app (iOS/macOS)
        return `http://maps.apple.com/?address=${encodedAddress}`;
      } else {
        // Fallback to Google Maps for non-Apple devices
        return `https://www.google.com/maps/search/?q=${encodedAddress}`;
      }
    },
    shareData() {
      let shareTitle = (input) => {
        let appName = this.getAppName.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"); // Escape special characters
        let regex = new RegExp(`^(.*?)\\s-\\s[^|]+ \\| ${appName}$`, "i");

        const match = input.match(regex);

        return match ? match[1] : null;
      };
      return {
        title: `Directions to ${shareTitle(document.title)}\n`,
        text: `\nSent via ${this.getAppName} https://mytrace.com`,
        url: this.shareURL,
      };
    },
    minHeight() {
      return this.height
        ? this.height
        : this.hideOverlay || this.hideAddress
        ? "225px"
        : "250px";
    },
  },
};
</script>

<style scoped>
.marker::after {
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-top: 9px solid #f5f5f5; /* Same as background */
  content: "";
  height: 0;
  left: 50%;
  position: absolute;
  top: 95%;
  transform: translate(-50%, 0);
  z-index: 1;
}
.fab-overlay {
  position: absolute;
  /* backdrop-filter: blur(3px); */
  width: 100%;
  bottom: 0;
}

.directions-overlay {
  position: absolute;
  width: 100%;
  bottom: 0;
}
</style>
